import React, { Component } from "react";
import { Modal, Form, Input, FormInstance } from "antd";

interface FormProps {
    data: number
    visible: boolean,
    confirmLoading: boolean,
    onCreate: (values: number) => void,
    onCancel: () => void,
}

class UpMinute extends Component<FormProps> {
    
    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    render () {

        const { 
            visible, onCancel, onCreate, data,
   confirmLoading,
         } = this.props;
        const layout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 16 },
        };

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                confirmLoading={confirmLoading}
                title='编辑闲置时间'
                okText='确定'
                cancelText='取消'
                onCancel={onCancel}
                onOk={
                    () => {
                        this.formRelf.current!.validateFields().then(values => {
                            values.idleMinute = Number(values.idleMinute);
                            onCreate(values.idleMinute);
                            onCancel();
                        }).catch(info => {
                            // console.log('Valide Failed:', info);
                        })
                    }
                }
            >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    name='form'
                    initialValues={{
                      idleMinute: data,
                    }}
                    
                    >
                    <Form.Item label='闲置时间' name="idleMinute" rules={[
                        { required: true, message: '请输入闲置时间' },
                        { 
                            validator: (_, value) => {
                                if (!value || Number(value) >= 5) {
                                    return Promise.resolve();
                                }
                                return Promise.reject('闲置时间不能低于5分钟');
                            }
                        }
                    ]}>
                        <Input type="number" min={5} max={100} placeholder="请输入闲置时间" addonAfter="分钟" />
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default UpMinute